import axios from 'axios';

const API_URL = '/leads';

/**
 * Get all leads
 */
const getLeads = async (params = {}) => {
  const response = await axios.get(`${API_URL}/`, { params });
  return response.data;
};

/**
 * Get leads by project
 */
const getLeadsByProject = async (projectId, params = {}) => {
  const response = await axios.get(`${API_URL}/project/${projectId}/`, { params });
  return response.data;
};

/**
 * Get lead by ID
 */
const getLead = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/`);
  return response.data;
};

/**
 * Create new lead
 */
const createLead = async (data) => {
  const response = await axios.post(`${API_URL}/`, data);
  return response.data;
};

/**
 * Update lead
 */
const updateLead = async (id, data) => {
  const response = await axios.patch(`${API_URL}/${id}/`, data);
  return response.data;
};

/**
 * Delete lead
 */
const deleteLead = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}/`);
  return response.data;
};

/**
 * Change lead status
 */
const changeStatus = async (id, data) => {
  const response = await axios.patch(`${API_URL}/${id}/status/`, data);
  return response.data;
};

/**
 * Mark lead as contacted
 */
const markContacted = async (id, data = {}) => {
  const response = await axios.post(`${API_URL}/${id}/mark-contacted/`, data);
  return response.data;
};

/**
 * Bulk assign leads
 */
const bulkAssign = async (data) => {
  const response = await axios.post(`${API_URL}/bulk-assign/`, data);
  return response.data;
};

/**
 * Import leads from Excel
 */
const importLeads = async (formData) => {
  const response = await axios.post(`${API_URL}/import/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

/**
 * Download import template
 */
const downloadTemplate = async () => {
  const response = await axios.get(`${API_URL}/import/template/`, {
    responseType: 'blob',
  });
  return response.data;
};

/**
 * Get import logs
 */
const getImportLogs = async (params = {}) => {
  const response = await axios.get(`${API_URL}/import/logs/`, { params });
  return response.data;
};

/**
 * Add note to lead
 */
const addNote = async (id, data) => {
  const response = await axios.post(`${API_URL}/${id}/notes/`, data);
  return response.data;
};

/**
 * Upload document to lead
 */
const uploadDocument = async (id, formData) => {
  const response = await axios.post(`${API_URL}/${id}/documents/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

/**
 * Get dashboard data
 */
const getDashboard = async () => {
  const response = await axios.get(`${API_URL}/dashboard/`);
  return response.data;
};

const leadService = {
  getLeads,
  getLeadsByProject,
  getLead,
  createLead,
  updateLead,
  deleteLead,
  changeStatus,
  markContacted,
  bulkAssign,
  importLeads,
  downloadTemplate,
  getImportLogs,
  addNote,
  uploadDocument,
  getDashboard,
};

export default leadService;